import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { hasFlag } from 'country-flag-icons';

import 'country-flag-icons/3x2/flags.css';

/** `CountryFlag` component properties. */
export interface Props {
  flag: string;
}


declare module 'vue/types/vue' {
  export interface Vue {
    CountryFlag: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'CountryFlag' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    flag: null
  },
  setup(__props: any) {

const props = __props as {
  flag: string;
};



const displayFlag = computed(() => {
  let value: string;

  if (props.flag && hasFlag(props.flag)) {
    value = props.flag;
  } else {
    value = '';
  }

  return value;
});

return { __sfc: true,props, displayFlag }
}

})